module.exports = __webpack_public_path__ + "static/media/AccessAcceleratedAnnualReport2021_June.55fe0118.pdf";